/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

css = require('../css/card-box.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  getDefaultProps: function() {
    return {
      customClassNames: [],
      type: 'white',
      didClick: null
    };
  },
  displayName: 'CardBox',
  handleClick: function() {
    var base;
    if (typeof (base = this.props).didClick === "function") {
      base.didClick(this.props.id);
    }
  },
  render: function() {
    var classes;
    classes = [css['card-box']].concat(this.props['customClassNames']);
    if (this.props.type === 'white') {
      classes.push(css['white-card']);
    }
    if (this.props.type === 'black') {
      classes.push(css['black-card']);
    }
    if (this.props.didClick != null) {
      classes.push(css['clickable']);
    }
    classes = classes.join(' ');
    return React.createElement("div", {
      "className": classes,
      "onClick": this.handleClick
    }, this.props.children);
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "card-box.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/card-box.cjsx
 ** module id = 247
 ** module chunks = 0
 **/